import {Component} from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import {change, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {
    convertDateToFields,
    convertDateWithLocalTimeZone, extractDiscountItemCondition,
    extractDiscountScope,
    getLocalTimeZoneName
} from '../shared/functions';

/**
 * A component to retrieve Discount data and populate the record
 *
 */
class DiscountDuplication extends Component {
    constructor(props) {
        super(props);

        const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
        const id = urlParams.get('duplicate');
        const type = urlParams.get('type');

        this.state = {
            discountID: id ? id : null,
            type: type ? type : null,
        };
    }

    componentDidMount() {
        if (this.state.discountID && this.state.type) {
            this.fetchDiscountData();
        }
    }

    /**
     * API call to retrieve Discount by ID
     */
    fetchDiscountData() {
        const params = {
            id: this.state.discountID,
            type: this.state.type
        };
        const resource = productResources.Discounts.GET_ONE(params);

        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        const tzName = getLocalTimeZoneName();

                        let discountType = result.data.payload.scope.startsWith('bxgy_type') ? 'bxgy' : 'regular';
                        let {
                            type,
                            scope,
                            item_condition,
                            item_action,
                            valid_from,
                            valid_to,
                            automatic,
                            weight,
                            item_action_limit,
                            active
                        } = result.data.payload;
                        const validFromDate = new Date(valid_from);
                        const validToDate = new Date(valid_to);
                        const fromFields = convertDateToFields(validFromDate);
                        const toFields = convertDateToFields(validToDate);
                        const validFromString = convertDateWithLocalTimeZone(validFromDate, false);
                        const validToString = convertDateWithLocalTimeZone(validToDate, false);

                        let valid_from_date = validFromDate;
                        let valid_from_string = valid_from.substring(0, 10);
                        let valid_from_hour = fromFields.hour;
                        let valid_from_min = fromFields.min;
                        let valid_from_ampm = fromFields.ampm;
                        let valid_from_tz = validFromString + ' ' + tzName;

                        let valid_to_date = validToDate;
                        let valid_to_string = valid_to.substring(0, 10);
                        let valid_to_hour = toFields.hour;
                        let valid_to_min = toFields.min;
                        let valid_to_ampm = toFields.ampm;
                        let valid_to_tz = validToString + ' ' + tzName;

                        this.props.dispatch(change('record-form', 'discount_type', discountType));
                        this.props.dispatch(change('record-form', 'type', type));
                        this.props.dispatch(change('record-form', 'scope', scope));
                        this.props.dispatch(change('record-form', 'item_condition', item_condition));
                        this.props.dispatch(change('record-form', 'item_action', item_action));

                        this.props.dispatch(change('record-form', 'valid_from_date', valid_from_date));
                        this.props.dispatch(change('record-form', 'valid_from_string', valid_from_string));
                        this.props.dispatch(change('record-form', 'valid_from_hour', valid_from_hour));
                        this.props.dispatch(change('record-form', 'valid_from_min', valid_from_min));
                        this.props.dispatch(change('record-form', 'valid_from_ampm', valid_from_ampm));
                        this.props.dispatch(change('record-form', 'valid_from_tz', valid_from_tz));
                        this.props.dispatch(change('record-form', 'valid_to_date', valid_to_date));
                        this.props.dispatch(change('record-form', 'valid_to_string', valid_to_string));
                        this.props.dispatch(change('record-form', 'valid_to_hour', valid_to_hour));
                        this.props.dispatch(change('record-form', 'valid_to_min', valid_to_min));
                        this.props.dispatch(change('record-form', 'valid_to_ampm', valid_to_ampm));
                        this.props.dispatch(change('record-form', 'valid_to_tz', valid_to_tz));

                        this.props.dispatch(change('record-form', 'automatic', automatic));
                        this.props.dispatch(change('record-form', 'weight', weight));
                        this.props.dispatch(change('record-form', 'item_action_limit', item_action_limit));
                        this.props.dispatch(change('record-form', 'active', active));


                        if (discountType === 'bxgy') {
                            let priceDifference = (item_action === 'percent_off = 100') ? 'free' : 'percentage';
                            const percentOff = parseFloat(item_action.match(/percent_off = (\d{1,3}(?:\.\d+)?)/)[1]);
                            const buyAndGetQty = scope.match(/bxgy_type = (\d+),(\d+)/);

                            let presetType = 'custom';
                            if (scope.endsWith('buy_type = ITEM | get_type = ANY')) {
                                presetType = 'preset_products_any';
                            } else if (scope.endsWith('buy_type = ITEM | get_type = SAME')) {
                                presetType = 'preset_products_same';
                            } else if (scope.endsWith('buy_type = CATEGORY | get_type = SAME')) {
                                presetType = 'preset_categories_same';
                            }

                            this.props.dispatch(change('record-form', 'price_difference', priceDifference));
                            this.props.dispatch(change('record-form', 'discount_amount', percentOff));
                            this.props.dispatch(change('record-form', 'buy_qty', buyAndGetQty[1]));
                            this.props.dispatch(change('record-form', 'get_qty', buyAndGetQty[2]));
                            this.props.dispatch(change('record-form', 'preset_custom', presetType));

                            const buyObj = extractDiscountScope(scope, 'buy');
                            const getObj = extractDiscountScope(scope, 'get');

                            if (buyObj[0]) {
                                this.props.dispatch(change('record-form', 'buy_andor', buyObj[0].logicalOperator));
                                let addedItems = [];
                                buyObj.forEach((item) => {
                                    item.values.forEach((itemVal) => {
                                        itemVal = (itemVal === 'CATEGORY') ? 'All Categories' : itemVal;
                                        addedItems.push({
                                            id: itemVal,
                                            name: itemVal,
                                            type: item.type
                                        });
                                    })
                                })
                                this.props.dispatch(change('record-form', 'buy_values', addedItems));
                            }
                            if (getObj[0]) {
                                this.props.dispatch(change('record-form', 'get_andor', getObj[0].logicalOperator));
                                let addedItems = [];
                                getObj.forEach((item) => {
                                    item.values.forEach((itemVal) => {
                                        itemVal = (itemVal === 'CATEGORY') ? 'All Categories' : itemVal;
                                        addedItems.push({
                                            id: itemVal,
                                            name: itemVal,
                                            type: item.type
                                        });
                                    })
                                })
                                this.props.dispatch(change('record-form', 'get_values', addedItems));
                            }

                            const itemCondition = extractDiscountItemCondition(item_condition);
                            if (itemCondition.dba) {
                                this.props.dispatch(change('record-form', 'add_condition_dba_include', itemCondition.dba.comparison));
                                let addedItems = [];
                                itemCondition.dba.values.forEach((dba) => {
                                    addedItems.push({
                                        id: dba,
                                        name: dba,
                                        comparison: itemCondition.dba.comparison,
                                    });
                                })
                                this.props.dispatch(change('record-form', 'dba_values', addedItems));
                            }

                            if (itemCondition.location) {
                                this.props.dispatch(change('record-form', 'add_condition_location_include', itemCondition.location.comparison));
                                let addedItems = [];
                                itemCondition.location.values.forEach((location) => {
                                    addedItems.push({
                                        id: location,
                                        name: location,
                                        comparison: itemCondition.location.comparison,
                                    });
                                })
                                this.props.dispatch(change('record-form', 'location_values', addedItems));
                            }

                            if (scope.indexOf('buy_category') !== -1) {
                                this.props.dispatch(change('record-form', 'buy_add_item_product', null));
                            }
                            if (scope.indexOf('buy_item') !== -1) {
                                this.props.dispatch(change('record-form', 'buy_add_item_category', null));
                            }
                            if (scope.indexOf('buy_categories') !== -1 || scope.indexOf('buy_type') !== -1) {
                                this.props.dispatch(change('record-form', 'buy_add_item_category', null));
                                this.props.dispatch(change('record-form', 'buy_add_item_product', null));
                            }

                        }

                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
};

DiscountDuplication.propTypes = {
    addField: PropTypes.bool,
    record: PropTypes.object
};

DiscountDuplication.defaultProps = {
    addField: true
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'record-form',
        enableReinitialize: true,
    }),
);

export default enhance(DiscountDuplication);


// WEBPACK FOOTER //
// ./src/Fuse/components/DiscountDuplication.js